import { pgTable, text, timestamp, integer, bigint, index, foreignKey, jsonb } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { fileAccess, fileStatus, storageProvider } from './enums';

export const file = pgTable('File', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  originalName: text().notNull(),
  fileName: text().notNull(),
  mimeType: text().notNull(),
  size: bigint({ mode: 'number' }).notNull(),
  path: text().notNull(),
  bucket: text().notNull(),
  provider: storageProvider().default('LOCAL').notNull(),
  access: fileAccess().default('PUBLIC').notNull(),
  status: fileStatus().default('UPLOADED').notNull(),
  meta: jsonb(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
});

export const fileUsage = pgTable('FileUsage', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  fileId: integer().notNull(),
  entityId: integer().notNull(),
  entityType: text().notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('FileUsage_entityId_entityType_idx').using('btree', table.entityId.asc().nullsLast(), table.entityType.asc().nullsLast()),
  index('FileUsage_fileId_idx').using('btree', table.fileId.asc().nullsLast()),
  foreignKey({
    columns: [table.fileId],
    foreignColumns: [file.id],
    name: 'FileUsage_fileId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);
